import { PropsWithChildren } from 'react';

import { Content, ContentWrapper } from './styled';

type Props = PropsWithChildren<{
  className?: string;
}>;

const PageWrapper = ({ children, className }: Props): JSX.Element => {
  return (
    <ContentWrapper className={className} data-testid="pageContentWrapper">
      <Content data-testid="pageContentDetails">{children}</Content>
    </ContentWrapper>
  );
};

export default PageWrapper;
